import HBMessage from "@/components/HBMessage";
import ReportModal from "@/components/ReportModal";
import { report } from "@/services";
import { checkLogin } from "@/utils/open";
import { useMemoizedFn } from "ahooks";

/**采集举报 */
export function usePinReport(
  record: IPin,
  contentType: string,
  searchWord?: string
) {
  const onReport = useMemoizedFn(async () => {
    const user = await checkLogin({
      source_location: "采集举报",
    });

    if (!user) {
      return;
    }

    ReportModal.open({
      reportType: "采集",
      reportPinId: record?.pin_id,
      reportContentId: record?.file_material?.material_id,
      reportFileId: record?.file_id,
      reportBoardId: record?.board_id,
      contentType: contentType,
      searchWord: searchWord,
      onOk: async (values) => {
        const result = await report({
          type: "pin",
          ...values,
          id: record?.pin_id,
        });
        if (!result.err) {
          HBMessage.success(
            "谢谢你对花瓣的贡献，花瓣的工作人员会及时处理你的举报的"
          );
        } else {
          HBMessage.success("已收到您的举报信息，我们会尽快处理的");
        }
      },
    });
  });

  return {
    onReport,
  };
}
